export const RHYTHM_REWARD_CONFIG = {
  timing: {
    perfectWindow: 0.2,
    goodWindow: 0.42,
    maxJudgementWindow: 0.78
  },
  combo: {
    maxMultiplier: 3,
    multiplierStep: 0.25,
    resetOnMiss: true
  },
  floatingText: {
    offsetY: -86,
    durationMs: 620,
    risePx: 28,
    fontSize: "18px"
  },
  magnet: {
    enabled: true,
    baseRadius: 86,
    strongRadius: 128,
    pullStrength: 8.5,
    maxPullPxPerSecond: 420,
    minDistance: 8
  }
} as const;
